import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorProductItemBundlingSearch = () => {
  const productItemBundlingSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/product/bundling/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { productItemBundlingSearch }
}

export default InteractorProductItemBundlingSearch
